export default {
    // A
    attachHeadshot: 'Attach headshot',

    // C
    content_flagged_as_incompleted: 'Content has been flagged as incomplete',

    // F
    files: 'Files',
    flag_as_incompleted: 'Under Review',

    // M
    move_to_human_qc: 'Move to Human QC',

    // P
    proofing: 'Proofing',

    // R
    retry_agent_qc: 'Retry Agent QC',
    ready_to_edit: 'Resume My Edit',

    // S
    select_reason_for_flagging: 'Select reason(s) for flagging',
}
